import { render, staticRenderFns } from "./HasBeenDownloadedColumn.vue?vue&type=template&id=0c4738ac"
import script from "./HasBeenDownloadedColumn.ts?vue&type=script&lang=ts&external"
export * from "./HasBeenDownloadedColumn.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c4738ac')) {
      api.createRecord('0c4738ac', component.options)
    } else {
      api.reload('0c4738ac', component.options)
    }
    module.hot.accept("./HasBeenDownloadedColumn.vue?vue&type=template&id=0c4738ac", function () {
      api.rerender('0c4738ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Processes/components/list/columns/HasBeenDownloadedColumn/HasBeenDownloadedColumn.vue"
export default component.exports